import { render, staticRenderFns } from "./PackageAccess.vue?vue&type=template&id=2fd66322"
import script from "./PackageAccess.vue?vue&type=script&lang=js"
export * from "./PackageAccess.vue?vue&type=script&lang=js"
import style0 from "./PackageAccess.vue?vue&type=style&index=0&id=2fd66322&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports